import { baseUrl } from './http.api'

const install = (Vue, vm) => {

	uni.$u.http.setConfig((config) => {
		config.baseURL = baseUrl
		config.timeout = 60000
		return config
	})


	let ordinaryLogin = (params = {}) => uni.$u.http.get('web/account/ordinaryLogin', { params })
	let wxEmpower = (params = {}) => uni.$u.http.get('web/account/wxEmpower', { params })
	let editUserInfo = (data = {}) => vm.$u.http.post('web/account/editUserInfo', data)
	let getUserInfo = (params = {}) => vm.$u.http.get('web/account/getUserInfo', { params })
	let roomsList = (params = {}) => vm.$u.http.get('web/rooms/roomsList', { params })
	let getRoomUseTime = (data = {}) => vm.$u.http.post('web/rooms/getRoomUseTime', data)
	let userPage = (data = {}) => vm.$u.http.post('web/meeting/userPage', data)
	let getRoomDetail = (params = {}) => vm.$u.http.get('web/rooms/getRoomDetail', { params })
	let reservationMeeting = (data = {}) => vm.$u.http.post('web/meeting/reservationMeeting', data)
	let meetingDetail = (params = {}) => vm.$u.http.get('web/meeting/meetingDetail', { params })
	let getQrCode = (params = {}) => vm.$u.http.get('web/meeting/getQrCode', { params })
	let reservationCancel = (params = {}) => vm.$u.http.get('web/meeting/reservationCancel', { params })
	let resetPwd = (data = {}) => vm.$u.http.post('web/account/resetPwd', data)
	let myMeetingPage = (data = {}) => vm.$u.http.post('web/meeting/myMeetingPage', data)
	let myRoomsPage = (data = {}) => vm.$u.http.post('web/rooms/myRoomsPage', data)
	let findNoticePage = (data = {}) => vm.$u.http.post('web/notice/findNoticePage', data)
	let getMemberDTO = (params = {}) => vm.$u.http.get('web/notice/getMemberDTO', { params })
	let findNewNotice = (params = {}) => vm.$u.http.get('web/notice/findNewNotice', { params })
	let monthMeeting = (params = {}) => vm.$u.http.get('web/meeting/monthMeeting', { params })
	let roomsGetQrCode = (params = {}) => vm.$u.http.get('web/rooms/getQrCode', { params })
	let getSystemDictData = (params = {}) => vm.$u.http.get('web/util/getSystemDictData', { params })
	let getQrCodeImg = (params = {}) => vm.$u.http.get('web/meeting/getQrCodeImg', { params })
	let visitorLogin = (params = {}) => vm.$u.http.get('web/account/visitorLogin', { params })
	let visitorWxPhone = (data = {}) => vm.$u.http.post('web/account/visitorWxPhone', data)
	let getNoticeDetail = (params = {}) => vm.$u.http.get('web/notice/getNoticeDetail', { params })



	vm.$u.api = {
		ordinaryLogin,
		wxEmpower,
		editUserInfo,
		getUserInfo,
		roomsList,
		getRoomUseTime,
		userPage,
		getRoomDetail,
		reservationMeeting,
		meetingDetail,
		getQrCode,
		reservationCancel,
		resetPwd,
		myMeetingPage,
		myRoomsPage,
		findNoticePage,
		getMemberDTO,
		findNewNotice,
		monthMeeting,
		roomsGetQrCode,
		getSystemDictData,
		getQrCodeImg,
		visitorLogin,
		visitorWxPhone,
		getNoticeDetail
	}
}

export default { install }